// extracted by mini-css-extract-plugin
export default {"root":"xfTB1KiyDx1kg12Q47Ls"};